import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Props from './ContinueCheckoutBannerComponent';
import SelectLanguage from './SelectLanguage';

class ContinueCheckoutBanner extends Component<Props> {

    shouldShow = () => {
      if (this.props.isDynamicListing) {
        return true;
      }
      return this.props.showCartPill && (this.props.itemCount > 0 || this.props.forceShow);
    }

    render() {

      let pillClass = 'checkout__cart-pill';
      if (this.props.isDynamicListing) {
        pillClass += ' checkout__cart-pill-dynamic-listing';
      }

      return(
        <div className="checkout__bar">
          <SelectLanguage className='select-language--listing' />
          {this.shouldShow() && (
            <button className={pillClass} onClick={this.props.showCart}>
              {this.props.timeRemaining !== '00:00' &&
                <span className="checkout__cart-pill__timer">
                  <i className="icon-clock" />
                  <span className="checkout__cart-pill__timer-time" aria-live='polite'>
                    {this.props.timeRemaining}
                  </span>
                </span>
              }
              <span className="checkout__cart-pill__items">
                <i className="icon-shopping_cart" />
                {+this.props.itemCount > 0 && (
                  <span className="checkout__cart-pill__items-count">
                    {this.props.itemCount}
                  </span>
                )}
              </span>
            </button>
          )}
        </div>
      )
    }
}

ContinueCheckoutBanner.propTypes = {
    showCart: PropTypes.func.isRequired,
    amount: PropTypes.number.isRequired
}

export default ContinueCheckoutBanner
